module.exports = __webpack_public_path__ + "img/sa.4edde766.png";